import React, { useState } from 'react';

const PHOTOS = [
  { id: 1, annee: '1972', legende: 'Les Jackson 5 — tournée américaine', categorie: 'Jeunesse' },
  { id: 2, annee: '1979', legende: "Séance photo Off The Wall", categorie: 'Studio' },
  { id: 3, annee: '1982', legende: 'Répétitions Thriller — coulisses', categorie: 'Coulisses' },
  { id: 4, annee: '1983', legende: 'Motown 25 — avant le show', categorie: 'Coulisses' },
  { id: 5, annee: '1987', legende: 'Bad World Tour — Tokyo', categorie: 'Concerts' },
  { id: 6, annee: '1988', legende: 'Wembley Stadium — London', categorie: 'Concerts' },
  { id: 7, annee: '1993', legende: 'Super Bowl Halftime Show', categorie: 'Concerts' },
  { id: 8, annee: '1996', legende: 'HIStory Tour — Prague', categorie: 'Concerts' },
  { id: 9, annee: '2001', legende: '30th Anniversary — Madison Square Garden', categorie: 'Concerts' },
  { id: 10, annee: '2003', legende: 'Séance photo — dernier album', categorie: 'Studio' },
  { id: 11, annee: '2007', legende: 'Répétitions privées — Las Vegas', categorie: 'Coulisses' },
  { id: 12, annee: '2009', legende: 'This Is It — dernières répétitions', categorie: 'Coulisses' },
];

const VIDEOS = [
  { id: 1, titre: 'Thriller — Long Version', annee: '1983', duree: '14 min', type: 'CLIP OFFICIEL', desc: "Le clip le plus célèbre de l'histoire de la musique, réalisé par John Landis." },
  { id: 2, titre: 'Billie Jean — Motown 25', annee: '1983', duree: '4 min', type: 'LIVE HISTORIQUE', desc: 'La première apparition publique du moonwalk. Un moment qui a changé la culture pop.' },
  { id: 3, titre: 'Beat It — Live BAD Tour', annee: '1988', duree: '6 min', type: 'CONCERT', desc: 'Performance époustouflante lors du BAD World Tour à Wembley.' },
  { id: 4, titre: 'Black or White — Clip', annee: '1991', duree: '11 min', type: 'CLIP OFFICIEL', desc: 'Pionnier des effets de morphing, diffusé simultanément dans 27 pays.' },
  { id: 5, titre: 'Earth Song — BRIT Awards', annee: '1996', duree: '7 min', type: 'LIVE RARE', desc: 'Performance monumentale interrompue par Jarvis Cocker — un moment de télévision inoubliable.' },
  { id: 6, titre: 'This Is It — Making Of', annee: '2009', duree: '12 min', type: 'COULISSES', desc: 'Les répétitions de la tournée qui ne verra jamais le jour. Un testament artistique bouleversant.' },
];

const OUVRAGES = [
  { id: 1, titre: 'Moonwalk', annee: '1988', type: 'Autobiographie', desc: "L'autobiographie officielle de Michael Jackson — sa vie, son art, ses combats. Bestseller mondial." },
  { id: 2, titre: 'Dancing the Dream', annee: '1992', type: 'Recueil poétique', desc: 'Un recueil de poèmes et essais écrits par Michael lui-même. Sa vision du monde, de l\'amour et de la nature.' },
  { id: 3, titre: 'Thriller', annee: '1982', type: "Pochette d'album", desc: 'La pochette la plus vendue de l\'histoire. Photographie de Dick Zimmerman, Michael en smoking blanc.' },
  { id: 4, titre: 'BAD', annee: '1987', type: "Pochette d'album", desc: 'Esthétique cuir et chaînes — un virage visuel radical qui marqua le début d\'une nouvelle ère.' },
  { id: 5, titre: 'Dangerous', annee: '1991', type: "Pochette d'album", desc: 'Illustrée par Mark Ryden — une œuvre d\'art foisonnante de symboles et de références cachées.' },
  { id: 6, titre: 'HIStory', annee: '1995', type: "Pochette d'album", desc: 'Une statue monumentale de MJ en soldat — image de puissance et de résistance face aux attaques médiatiques.' },
];

const CATS_PHOTOS = ['Toutes', 'Jeunesse', 'Studio', 'Coulisses', 'Concerts'];
const TYPES_VIDEO = ['Tous', 'CLIP OFFICIEL', 'LIVE HISTORIQUE', 'CONCERT', 'LIVE RARE', 'COULISSES'];
const TYPES_OUVRAGE = ['Tous', 'Autobiographie', 'Recueil poétique', "Pochette d'album"];

const COULEURS_TYPE = {
  'CLIP OFFICIEL': '#8b1a2a',
  'LIVE HISTORIQUE': '#1a3a6b',
  'CONCERT': '#1a5a3a',
  'LIVE RARE': '#6b4a1a',
  'COULISSES': '#5a1a6b',
};

const COULEURS_OUVRAGE = {
  'Autobiographie': '#f5e8e8',
  'Recueil poétique': '#e8f0f5',
  "Pochette d'album": '#f0e8f5',
};

function BtnFiltre({ actif, onClick, label }) {
  return (
    <button onClick={onClick} style={{
      padding: '7px 14px', borderRadius: 8,
      border: actif ? '2px solid #8b1a2a' : '2px solid #e8d5d0',
      background: actif ? '#8b1a2a' : '#fff',
      color: actif ? '#fff' : '#4a3030',
      fontSize: 12, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap',
    }}>{label}</button>
  );
}

function BtnSection({ actif, onClick, label }) {
  return (
    <button onClick={onClick} style={{
      padding: '10px 24px', borderRadius: 8,
      border: actif ? '2px solid #8b1a2a' : '2px solid #e8d5d0',
      background: actif ? '#8b1a2a' : '#fff',
      color: actif ? '#fff' : '#4a3030',
      fontSize: 14, fontWeight: 700, cursor: 'pointer', whiteSpace: 'nowrap',
    }}>{label}</button>
  );
}

function Citation({ texte }) {
  return (
    <div style={{ marginTop: 36, background: '#fff', borderLeft: '4px solid #8b1a2a', borderRadius: '0 12px 12px 0', padding: '22px 28px', border: '1.5px solid #e8d5d0', borderLeftWidth: 4, borderLeftColor: '#8b1a2a' }}>
      <p style={{ fontFamily: 'Georgia,serif', fontSize: 16, color: '#3a2020', fontStyle: 'italic', lineHeight: 1.8 }}>{texte}</p>
      <cite style={{ fontSize: 12, color: '#8b1a2a', fontWeight: 700, letterSpacing: '0.08em', display: 'block', marginTop: 10 }}>— MICHAEL JACKSON</cite>
    </div>
  );
}

function SectionPhotos() {
  const [cat, setCat] = useState('Toutes');
  const filtrees = cat === 'Toutes' ? PHOTOS : PHOTOS.filter(p => p.categorie === cat);
  return (
    <div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 28 }}>
        {CATS_PHOTOS.map(c => <BtnFiltre key={c} actif={cat === c} onClick={() => setCat(c)} label={c} />)}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 18 }}>
        {filtrees.map(p => (
          <div key={p.id} style={{ background: '#fff', borderRadius: 12, border: '1.5px solid #e8d5d0', overflow: 'hidden', transition: 'box-shadow 0.2s', boxShadow: '0 2px 8px rgba(139,26,42,0.05)' }}
            onMouseEnter={e => e.currentTarget.style.boxShadow = '0 6px 20px rgba(139,26,42,0.12)'}
            onMouseLeave={e => e.currentTarget.style.boxShadow = '0 2px 8px rgba(139,26,42,0.05)'}
          >
            <div style={{ height: 160, background: '#f5eeeb', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
              <span style={{ fontSize: 40, opacity: 0.3 }}>📷</span>
              <div style={{ position: 'absolute', top: 10, right: 10, background: '#8b1a2a', color: '#fff', fontSize: 12, fontWeight: 700, padding: '2px 8px', borderRadius: 10 }}>{p.categorie}</div>
            </div>
            <div style={{ padding: '12px 14px' }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: '#8b1a2a', marginBottom: 3 }}>{p.annee}</div>
              <div style={{ fontSize: 13, color: '#1a1010', lineHeight: 1.5 }}>{p.legende}</div>
            </div>
          </div>
        ))}
      </div>
      <Citation texte="I'm just like anyone. I cut and I bleed. And I embarrass easily." />
    </div>
  );
}

function SectionVideos() {
  const [type, setType] = useState('Tous');
  const filtrees = type === 'Tous' ? VIDEOS : VIDEOS.filter(v => v.type === type);
  return (
    <div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 28 }}>
        {TYPES_VIDEO.map(t => <BtnFiltre key={t} actif={type === t} onClick={() => setType(t)} label={t} />)}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 20 }}>
        {filtrees.map(v => (
          <div key={v.id} style={{ background: '#fff', borderRadius: 12, border: '1.5px solid #e8d5d0', overflow: 'hidden', transition: 'box-shadow 0.2s', boxShadow: '0 2px 8px rgba(139,26,42,0.05)' }}
            onMouseEnter={e => e.currentTarget.style.boxShadow = '0 6px 20px rgba(139,26,42,0.12)'}
            onMouseLeave={e => e.currentTarget.style.boxShadow = '0 2px 8px rgba(139,26,42,0.05)'}
          >
            <div style={{ height: 140, background: '#1a0808', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
              <div style={{ width: 48, height: 48, borderRadius: '50%', background: 'rgba(139,26,42,0.85)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontSize: 18, cursor: 'pointer' }}>▶</div>
              <div style={{ position: 'absolute', top: 10, left: 10, background: COULEURS_TYPE[v.type] || '#8b1a2a', color: '#fff', fontSize: 12, fontWeight: 700, padding: '3px 10px', borderRadius: 10 }}>{v.type}</div>
              <div style={{ position: 'absolute', bottom: 10, right: 10, background: 'rgba(0,0,0,0.6)', color: '#fff', fontSize: 12, padding: '2px 8px', borderRadius: 6 }}>{v.duree}</div>
            </div>
            <div style={{ padding: '14px 16px' }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: '#1a1010', marginBottom: 4 }}>{v.titre}</div>
              <div style={{ fontSize: 12, color: '#8b1a2a', fontWeight: 600, marginBottom: 8 }}>{v.annee}</div>
              <div style={{ fontSize: 12, color: '#6a5050', lineHeight: 1.6 }}>{v.desc}</div>
            </div>
          </div>
        ))}
      </div>
      <Citation texte="I had to go through a lot to get to this point, but I am very proud to say that the music has always been there for me." />
    </div>
  );
}

function SectionOuvrages() {
  const [type, setType] = useState('Tous');
  const filtrees = type === 'Tous' ? OUVRAGES : OUVRAGES.filter(o => o.type === type);
  return (
    <div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 28 }}>
        {TYPES_OUVRAGE.map(t => <BtnFiltre key={t} actif={type === t} onClick={() => setType(t)} label={t} />)}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 20 }}>
        {filtrees.map(o => (
          <div key={o.id} style={{ background: '#fff', borderRadius: 12, border: '1.5px solid #e8d5d0', overflow: 'hidden', transition: 'box-shadow 0.2s', boxShadow: '0 2px 8px rgba(139,26,42,0.05)' }}
            onMouseEnter={e => e.currentTarget.style.boxShadow = '0 6px 20px rgba(139,26,42,0.12)'}
            onMouseLeave={e => e.currentTarget.style.boxShadow = '0 2px 8px rgba(139,26,42,0.05)'}
          >
            <div style={{ height: 160, background: COULEURS_OUVRAGE[o.type] || '#f5eeeb', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
              <span style={{ fontSize: 44, opacity: 0.35 }}>{o.type === 'Autobiographie' || o.type === 'Recueil poétique' ? '📖' : '🎨'}</span>
              <div style={{ position: 'absolute', top: 10, left: 10, background: '#8b1a2a', color: '#fff', fontSize: 12, fontWeight: 700, padding: '2px 10px', borderRadius: 10 }}>{o.type}</div>
            </div>
            <div style={{ padding: '14px 16px' }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: '#1a1010', marginBottom: 3 }}>{o.titre}</div>
              <div style={{ fontSize: 12, color: '#8b1a2a', fontWeight: 600, marginBottom: 8 }}>{o.annee}</div>
              <div style={{ fontSize: 12, color: '#6a5050', lineHeight: 1.6 }}>{o.desc}</div>
            </div>
          </div>
        ))}
      </div>
      <Citation texte="In my darkest hour, when I can not bear to be alone, I write — there's music in words, and there are words in music." />
    </div>
  );
}

export default function Michael() {
  const [section, setSection] = useState('photos');

  return (
    <div style={{ background: '#fafaf8', minHeight: '100vh', fontFamily: 'Arial,sans-serif' }}>

      {/* HERO */}
      <div style={{ background: '#1a0808', padding: '56px 48px 48px' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <div style={{ fontSize: 12, letterSpacing: '0.2em', color: '#e8a0a0', fontWeight: 700, marginBottom: 16 }}>MICHAEL JACKSON</div>
          <h1 style={{ fontFamily: 'Georgia,serif', fontSize: 36, color: '#fff', fontWeight: 400, lineHeight: 1.45, marginBottom: 16 }}>
            L'homme, l'artiste,<br /><em style={{ color: '#e8a0a0', fontStyle: 'italic' }}>la légende</em>
          </h1>
          <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.6)', lineHeight: 1.85, maxWidth: 560 }}>
            Photos rares, vidéos inoubliables, livres et pochettes d'albums — tout ce qui fait de lui bien plus qu'une icône.
          </p>
        </div>
      </div>

      {/* CONTENU */}
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '52px 48px' }}>

        {/* Sélecteur de section */}
        <div style={{ display: 'flex', gap: 12, marginBottom: 48, flexWrap: 'wrap' }}>
          <BtnSection actif={section === 'photos'} onClick={() => setSection('photos')} label="📷 Photos rares" />
          <BtnSection actif={section === 'videos'} onClick={() => setSection('videos')} label="🎬 Vidéos" />
          <BtnSection actif={section === 'ouvrages'} onClick={() => setSection('ouvrages')} label="📚 Ouvrages" />
        </div>

        {/* Titre de section */}
        {section === 'photos' && <>
          <div style={{ fontSize: 12, letterSpacing: '0.15em', color: '#8b1a2a', fontWeight: 700, marginBottom: 8 }}>PHOTOS RARES</div>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: 28, color: '#1a1010', marginBottom: 6 }}>Des instants précieux</div>
          <div style={{ fontSize: 14, color: '#6a5050', marginBottom: 28, lineHeight: 1.6 }}>Photos rares ou méconnues — coulisses, moments privés, séances photo exceptionnelles.</div>
          <SectionPhotos />
        </>}

        {section === 'videos' && <>
          <div style={{ fontSize: 12, letterSpacing: '0.15em', color: '#8b1a2a', fontWeight: 700, marginBottom: 8 }}>VIDÉOS</div>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: 28, color: '#1a1010', marginBottom: 6 }}>Clips & performances</div>
          <div style={{ fontSize: 14, color: '#6a5050', marginBottom: 28, lineHeight: 1.6 }}>Clips iconiques, lives rares, répétitions — la magie en mouvement.</div>
          <SectionVideos />
        </>}

        {section === 'ouvrages' && <>
          <div style={{ fontSize: 12, letterSpacing: '0.15em', color: '#8b1a2a', fontWeight: 700, marginBottom: 8 }}>OUVRAGES</div>
          <div style={{ fontFamily: 'Georgia,serif', fontSize: 28, color: '#1a1010', marginBottom: 6 }}>Livres & pochettes d'albums</div>
          <div style={{ fontSize: 14, color: '#6a5050', marginBottom: 28, lineHeight: 1.6 }}>Ses écrits, ses autobiographies, et les pochettes qui ont marqué l'histoire visuelle du pop.</div>
          <SectionOuvrages />
        </>}

      </div>
    </div>
  );
}
